import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RoutineRoutingModule } from './routine-routing.module';
import { ManageComponent } from './manage/manage.component';
import { AddComponent } from './add/add.component';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CommonComponentModule } from 'projects/app-core/src/app/components/commoncomponent.module';

import { RouterModule } from '@angular/router';
import { HttpLoaderFactory } from '../../app.module';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { ViewComponent } from './view/view.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@NgModule({
  declarations: [ManageComponent, AddComponent, ViewComponent],
  imports: [
    CommonComponentModule,
    CommonModule,
    RoutineRoutingModule,
    FormsModule,
    Select2Module,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    InfiniteScrollModule,
    NzUploadModule,
    NzIconModule,
    NzSelectModule,
    NzGridModule,
    NzInputModule,
    NzDividerModule,
    NzButtonModule,
    NzCardModule,
    NzCheckboxModule,
    NzSpinModule,
    NzPaginationModule,
    NzRateModule,
    NzSwitchModule,
    NzEmptyModule,
  ],
})
export class RoutineModule {}
